import React from "react";
import { CSSTransition } from "react-transition-group";

const ModalOverlay = (props) => {
  return (
    <div
      className={`modal !z-50 w-[90%] md:w-[40rem] bg-white shadow-lg rounded-lg p-8 ${props.className}`}
      style={props.style}
      onClick={(e) => e.stopPropagation()}
    >
      <header className={`text-primary  ${props.headerClass}`}>
        {props.header}
      </header>
      <div className={`text-md text-darkgray mt-1 ${props.descriptionClass}`}>
        {props.description}
      </div>
      <form
        onSubmit={
          props.onSubmit ? props.onSubmit : (event) => event.preventDefault()
        }
      >
        {props.children && (
          <div
            className={`py-4 pr-4 max-h-[60vh] overflow-y-auto ${props.bodyClass}`}
          >
            {props.children}
          </div>
        )}
        { props.footer &&
        <footer className={`py-4 px-2 ${props.footerClass}`}>
          {props.footer}
        </footer>
        }
      </form>
    </div>
  );
};

const Modal = (props) => {
  return (
    <>
      {props.show === true && (
        <div
          className="h-full w-full fixed top-0 left-0 bg-black bg-opacity-40 !z-50 flex items-center justify-center mt-0"
          onClick={props.onClose}
        >
          <CSSTransition
            in={props.show}
            mountOnEnter
            unmountOnExit
            timeout={200}
            classNames="modal"
          >
            <ModalOverlay {...props} />
          </CSSTransition>
        </div>
      )}
    </>
  );
};

export default Modal;
